export const MODULE_NAME = 'integrations/ga4'

export const EVENTS = {
  CONTACT: 'contact',
  RESTRICTED_RECOMENDED_CLICK: 'restricted_recomended_click',
  COTTAGE_PHONE_CLICK: 'ficha_phone_click',
  KEEP_SEARCHING: 'Ficha_ver-mas-alojamientos_click',
  HOLIDAYS_CLICK: 'Vacaciones_clic',
  RO_SUCCESS_BLOG_CLICK: 'ro-success-page_blog_clic',
  RO_CONTACT_CLICK: 'ro_contacto_clic',
  COTTAGE_VIEW_PRICES_LINK: 'cottage_view_prices_link',
  VIEW_PHONE: 'view_phone',
  CLICK_PHONE: 'click_phone',
  COTTAGE_CONVERSION_ALL: 'ficha_CRV-a-cualquier-solicitud',
  HOME_SIMPLE_BANNER_CLICK: 'home_simplebanner_clic',
  HOME_MEDIA_BANNER_CLICK: 'home_mediabanner_clic',
  HOME_FEATURED_DESTINATIONS_CLICK: 'home_featureddestinations_clic',
  HOME_IMAGE_BANNER_CLICK: 'home_imagebanner_clic',
}
